module.exports = __webpack_public_path__ + "img/trackd-logo.5aa1dde4.svg";